import { bool, elementType, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import FieldWithError from '../FieldWithError';
import LabeledBlock from '../LabeledBlock';

const LabeledFieldWithError = ({
  label,
  required,
  labelColor,
  labelFontSize,
  labelAs: LabelComp,
  ...rest
}) => (
  <LabeledBlock
    required={required}
    label={label}
    as={LabelComp}
    color={labelColor}
    fontSize={labelFontSize}
  >
    <FieldWithError {...rest} />
  </LabeledBlock>
);

LabeledFieldWithError.propTypes = {
  label: node,
  labelColor: string,
  labelFontSize: string,
  required: bool,
  name: string.isRequired,
  children: oneOfType([node, func]),
  type: string,
  as: elementType,
  labelAs: elementType,
  validate: func,
};

export default LabeledFieldWithError;
